<!--suppress ALL -->
<div class="row mt-2">
  <div class="col-10">
    <nav class="breadcrumb-one" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="javascript:void(0);">
          <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </a></li>
        <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/settings" translate>Settings</a></li>
        <li class="breadcrumb-item active" aria-current="page" translate>Update Account Requests</li>
        <li class="breadcrumb-item">
          <a href="https://www.youtube.com/watch?v=1mvWU2q56R8" target="_blank">
            <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
              <g id="Group">
                <path id="Path" fill="#06209f" stroke="none"
                      d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
              </g>
              <g id="g1"/>
            </svg>
          </a>
        </li>
      </ol>
    </nav>
  </div>
</div>
<div class="row">
  <div class="col-11">{{'Update Account Requests List' | translate}}</div>
  <div class="col-1">
    <button class="btn btn-primary" translate (click)="openModal()">Request Update</button>
  </div>
</div>


<!-- Sales tab content -->
<div class="tab-pane fade active show" id="icon-update-accounts-requests" role="tabpanel" aria-labelledby="icon-sales-tab">
  <div class="table-responsive mb-4 mt-4">
    <table id="update-accounts-requests-table" class="table table-hover non-hover" style="width:100%">
      <thead>
      <tr>
        <th translate>ID</th>
        <th translate>Action</th>
        <th translate>Status</th>
        <th translate>IBAN</th>
        <th translate>Bank</th>
        <th translate>License Number</th>
        <th translate>License Name</th>
        <th translate>License Type</th>
        <th translate>Mobile</th>
        <th translate>Identity Expiry</th>
        <th translate>Sales Volume</th>
        <th translate>Email</th>
        <th translate>Selling Scope</th>
        <th translate>Global Reason</th>
        <th translate>Hijri Birth Date</th>
        <th translate>Identity Number</th>
      </tr>
      </thead>
    </table>
  </div>
</div>
<!-- end tab content -->


<!-- Update account Modal -->
<div class="modal fade" id="updateAccountFormModal" tabindex="-1" role="dialog" aria-labelledby="cancelModalLabel" aria-hidden="true">
  <div class="modal-dialog" style="min-width: 75%">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" translate>Request Update Account</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body loading-form" *ngIf="submitting">
        <div class="d-flex">
          <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
        </div>
      </div>
      <div class="modal-body update-form" *ngIf="!requestId && !submitting">
        <!-- Angular Reactive Form -->
        <form [formGroup]="updateAccountForm" *ngIf="myBusiness">
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="iban" translate>IBAN</label>:
              <input formControlName="iban" id="iban" type="text" class="form-control">
            </div>
            <div class="col-md-6 form-group">
              <label for="bank" translate>Bank</label>:
              <select formControlName="bank" id="bank" type="text" class="form-control">
                <option *ngFor="let b of myBusiness.bankNames " [value]="b.key">{{currentLang == 'ar' ? b.valueAr : b.value }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label *ngIf="myBusiness.licenseType != 'freelancer'" for="licenseNumber" translate>License Number</label>:
              <input *ngIf="myBusiness.licenseType != 'freelancer'" formControlName="licenseNumber" id="licenseNumber" type="text" class="form-control">
              <label *ngIf="myBusiness.licenseType == 'freelancer'" for="licenseNumber" translate>Freelance Document</label>
              <input *ngIf="myBusiness.licenseType == 'freelancer'" (change)="handleFileChange($event)" formControlName="licenseNumber" id="licenseNumber" type="file" class="form-control" accept="application/pdf" disabled>
            </div>
            <div class="col-md-6 form-group">
              <label for="email" translate>Email</label>:
              <input formControlName="email" id="email" type="email" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="licenseType" translate>License Type</label>:
              <select disabled readonly formControlName="licenseType" id="licenseType" class="form-control">
                <option [value]="licenseType.key">{{currentLang == 'ar' ? licenseType.valueAr : licenseType.value }}</option>
              </select>
            </div>
            <div class="col-md-6 form-group">
              <label for="mobile" translate>Mobile</label>:
              <input formControlName="mobile" id="mobile" type="text" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label class="col-form-label" translate>Hijri Birth Date</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="d-flex flex-row date">
                    <select [ngClass]="{'is-invalid' : submitted && f.hijriBirthDay.errors}" formControlName="hijriBirthDay" class="form-control day">
                      <option value="" translate>{{'Choose Day' | translate}}</option>
                      <option [value]="day" *ngFor="let day of daysOfMonth">{{day}}</option>
                    </select>
                    &nbsp;&nbsp;
                    <select [ngClass]="{'is-invalid' : submitted && f.hijriBirthMonth.errors}" formControlName="hijriBirthMonth" class=" form-control month">
                      <option value="" translate>{{'Choose Month' | translate}}</option>
                      <option [value]="i" *ngFor="let month of monthsNames;let i = index">{{month}}</option>
                    </select>
                    &nbsp;&nbsp;
                    <input [ngClass]="{'is-invalid' : submitted && f.hijriBirthYear.errors}" formControlName="hijriBirthYear" type="text" class="form-control year" placeholder="{{'YYYY' | translate}}" id="hijriBirthYear" [maxLength]="4">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 form-group">
              <label for="identityNumber" translate>Identity Number</label>:
              <input formControlName="identityNumber" id="identityNumber" type="text" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="sellingScope" translate>Selling Scope</label>:
              <select formControlName="sellingScope" id="sellingScope" class="form-control">
                <option *ngFor="let b of myBusiness.sellingScopes " [value]="b.key">{{currentLang == 'ar' ? b.valueAr : b.value }}</option>
              </select>
            </div>
            <div class="col-md-6 form-group" *ngIf="updateAccountForm.controls['sellingScope'].value == 'global'">
              <label for="globalReason" translate>Global Reason</label>:
              <input formControlName="globalReason" id="globalReason" type="text" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="salesVolume" translate>Sales Volume</label>:
              <select formControlName="salesVolume" id="salesVolume" class="form-control">
                <option *ngFor="let b of myBusiness.salesVolumes " [value]="b.key">{{currentLang == 'ar' ? b.valueAr : b.value }}</option>
              </select>
            </div>
          </div>
        </form>
        <div *ngIf="getFormErrors(updateAccountForm).length > 0 && submitted">
          <h6>Form Errors:</h6>
          <ul>
            <li *ngFor="let error of getFormErrors(updateAccountForm)" class="text-danger">
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-body otp-form" *ngIf="requestId && !nafathRandomNumber && !submitting">
        <!-- Angular Reactive Form -->
        <form [formGroup]="sendAccountOtpForm" *ngIf="myBusiness">
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="otp" translate>OTP</label>:
              <input formControlName="otp" id="otp" type="text" class="form-control">
            </div>
          </div>
        </form>
        <div *ngIf="getFormErrors(sendAccountOtpForm).length > 0 && submitted">
          <h6>Form Errors:</h6>
          <ul>
            <li *ngFor="let error of getFormErrors(sendAccountOtpForm)" class="text-danger">
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-body nafath-form" *ngIf="requestId && nafathRandomNumber && !submitting">
        <div class="d-flex">
          <img alt="nafath logo" src="assets/img/nafath.png" style="width: 250px;" class="mx-auto"/>
        </div>
        <div>
          {{'Choose the following number in your nafath app and approve the request:' | translate}}
        </div>
        <div class="d-flex">
          <span style="font-size: 32pt" class="text-success mx-auto">{{nafathRandomNumber}}</span>
        </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="!nafathRandomNumber" type="button" class="btn btn-secondary" translate (click)="dismissForm()">Cancel</button>
        <button *ngIf="!requestId" type="button" class="btn btn-primary" translate (click)="submitForm()">Submit</button>
        <button *ngIf="requestId && !nafathRandomNumber" type="button" class="btn btn-primary" translate (click)="submitOtpForm()">Submit OTP</button>
        <div class="d-flex" *ngIf="requestId && nafathRandomNumber && nafathStatus && nafathStatus != 'COMPLETED'">
          <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
        </div>
        <div class="d-flex" *ngIf="requestId && nafathRandomNumber && nafathStatus && nafathStatus == 'COMPLETED'">
          <div class="mx-auto text-info align-self-center"><i style="font-size: 18pt" class="text-success fas fa-check-circle"></i></div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Update account Modal -->

<!-- View account Modal -->
<div class="modal fade" id="viewAccountFormModal" tabindex="-1" role="dialog" aria-labelledby="viewModalLabel" aria-hidden="true">
  <div class="modal-dialog" style="min-width: 75%">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" translate>View Update Account</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body loading-form" *ngIf="submitting">
        <div class="d-flex">
          <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
        </div>
      </div>
      <div class="modal-body update-form" *ngIf="!requestId && !submitting">
        <!-- Angular Reactive Form -->
        <form [formGroup]="viewAccountForm" *ngIf="myBusiness">
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="iban" translate>IBAN</label>:
              <input formControlName="iban" id="iban" type="text" class="form-control" readonly>
            </div>
            <div class="col-md-6 form-group">
              <label for="bank" translate>Bank</label>:
              <select formControlName="bank" id="bank" type="text" class="form-control" readonly>
                <option *ngFor="let b of myBusiness.bankNames " [value]="b.key">{{currentLang == 'ar' ? b.valueAr : b.value }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="licenseNumber" translate>License Number</label>:
              <input formControlName="licenseNumber" id="licenseNumber" type="text" class="form-control" readonly>
            </div>
            <div class="col-md-6 form-group">
              <label for="email" translate>Email</label>:
              <input formControlName="email" id="email" type="email" class="form-control" readonly>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="licenseType" translate>License Type</label>:
              <select formControlName="licenseType" id="licenseType" class="form-control" disabled readonly>
                <option *ngFor="let b of myBusiness.licenseTypes " [value]="b.key">{{currentLang == 'ar' ? b.valueAr : b.value }}</option>
              </select>
            </div>
            <div class="col-md-6 form-group">
              <label for="mobile" translate>Mobile</label>:
              <input formControlName="mobile" id="mobile" type="text" class="form-control" readonly>
            </div>
          </div>
          <div class="row">
<!--            <div class="col-md-6 form-group">-->
<!--              <label for="identityExpiry" translate>Identity Expiry</label>:-->
<!--              <input formControlName="identityExpiry" id="identityExpiry" type="date" class="form-control" readonly>-->
<!--            </div>-->
            <div class="col-md-6 form-group">
              <label for="salesVolume" translate>Sales Volume</label>:
              <select formControlName="salesVolume" id="salesVolume" class="form-control" readonly>
                <option *ngFor="let b of myBusiness.salesVolumes " [value]="b.key">{{currentLang == 'ar' ? b.valueAr : b.value }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="sellingScope" translate>Selling Scope</label>:
              <select formControlName="sellingScope" id="sellingScope" class="form-control" readonly>
                <option *ngFor="let b of myBusiness.sellingScopes " [value]="b.key">{{currentLang == 'ar' ? b.valueAr : b.value }}</option>
              </select>
            </div>
            <div class="col-md-6 form-group" *ngIf="viewAccountForm.controls['sellingScope'].value == 'global'">
              <label for="globalReason" translate>Global Reason</label>:
              <input formControlName="globalReason" id="globalReason" type="text" class="form-control" readonly>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="hijriBirthDate" translate>Hijri Birth Date</label>:
              <input formControlName="hijriBirthDate" id="hijriBirthDate" type="date" class="form-control" readonly>
            </div>
            <div class="col-md-6 form-group">
              <label for="identityNumber" translate>Identity Number</label>:
              <input formControlName="identityNumber" id="identityNumber" type="text" class="form-control" readonly>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="hijriBirthDate" translate>Reject Reason</label>:
              <textarea formControlName="rejectReason" id="rejectReason" class="form-control" readonly>
              </textarea>
            </div>
            <div class="col-md-6 form-group">
              <label for="identityNumber" translate>Reject Solution</label>:
              <textarea formControlName="rejectSolution" id="rejectSolution" class="form-control" readonly></textarea>
            </div>
          </div>
        </form>
        <div *ngIf="getFormErrors(updateAccountForm).length > 0 && submitted">
          <h6>Form Errors:</h6>
          <ul>
            <li *ngFor="let error of getFormErrors(updateAccountForm)" class="text-danger">
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="!nafathRandomNumber" type="button" class="btn btn-secondary" translate (click)="dismissForm()">OK</button>
      </div>
    </div>
  </div>
</div>
<!-- End View account Modal -->

<!-- cancel modal -->
<div class="modal fade" id="cancelModal" tabindex="-1" role="dialog" aria-labelledby="cancelModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="cancelModalLabel">Cancel Request</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{'Would you like to cancel request number' | translate}} <span id="requestNumber"></span>{{'?' | translate}}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>
<!-- end cancel modal -->

<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
